import React, { useState } from 'react';
import { Input, Button } from 'antd';
import { MailOutlined, CheckCircleOutlined } from '@ant-design/icons';
import api from '../../api';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setError(null);
    setLoading(true);
    try {
      await api.subscribeNewsletter({ email });
      setDone(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="newsletter-signup newsletter-signup--done">
        <CheckCircleOutlined className="newsletter-done-icon" />
        <p className="newsletter-done-text">You&apos;re subscribed! We&apos;ll keep you updated with our newsletter, including new articles.</p>
      </div>
    );
  }

  return (
    <div className="newsletter-signup">
      <div className="newsletter-signup-inner">
        <div className="newsletter-signup-text">
          <MailOutlined className="newsletter-mail-icon" />
          <div>
            <p className="newsletter-signup-title">Stay in the loop</p>
            <p className="newsletter-signup-subtitle">Subscribe to our newsletter for updates, including new articles.</p>
          </div>
        </div>
        <form className="newsletter-signup-form" onSubmit={handleSubmit} noValidate>
          <Input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value); setError(null);
            }}
            className="newsletter-email-input"
            size="large"
            disabled={loading}
          />
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={loading}
            className="newsletter-submit-btn"
          >
            Subscribe
          </Button>
        </form>
        {error && <p className="newsletter-error">{error}</p>}
      </div>
    </div>
  );
};

export default NewsletterSignup;
